import { render, staticRenderFns } from "./UkrTreasuresHead.vue?vue&type=template&id=4e4930ea&scoped=true"
import script from "./UkrTreasuresHead.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresHead.vue?vue&type=script&lang=js"
import style0 from "./UkrTreasuresHead.vue?vue&type=style&index=0&id=4e4930ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4930ea",
  null
  
)

export default component.exports